import { render, staticRenderFns } from "./404.vue?vue&type=template&id=d8587114&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8587114",
  null
  
)

export default component.exports